module.exports = __webpack_public_path__ + "static/media/icon-check-list-checked-white.4be8b235.svg";